/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ContainerModel, TextInputModel, TextModel } from '@typescript-kit/view';

export class TimeRecordingMenuComponentModel extends ContainerModel {

  get employeeName(): TextModel {
    return this.items.get('employeeName') as TextModel;
  }

  get monthText(): TextModel {
    return this.items.get('monthText') as TextModel;
  }

  get monthComment(): TextInputModel {
    return this.items.get('monthComment') as TextInputModel;
  }

}
